import React from 'react';
import { Footer, Navbar } from "../components";

const TermsAndConditions = () => {
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 className="mb-4" style={{ borderBottom: '2px solid #eee', paddingBottom: '10px' }}>
            Terms and Conditions
          </h1>
          <p><strong>Balvindra Instruments Corporation</strong></p>
          <p><strong>Website:</strong> scientificinstruments.in</p>
          <p><strong>Last Updated:</strong> 10 September 2024</p>

          <h2 className="mt-4 mb-3">1. Acceptance of Terms</h2>
          <p>
            By accessing or using this website, you agree to be bound by these Terms and
            Conditions. Users must be at least 18 years of age.
          </p>

          <h2 className="mt-4 mb-3">2. Changes to Terms</h2>
          <p>
            We reserve the right to update these Terms at any time. Continued use of the
            website constitutes acceptance of revised Terms.
          </p>

          <h2 className="mt-4 mb-3">3. Products and Services</h2>
          <p>
            We supply scientific instruments for educational institutions, laboratories,
            hospitals, and research organizations. Product availability may change without
            notice.
          </p>

          <h2 className="mt-4 mb-3">4. Orders and Payments</h2>
          <ul>
            <li>Orders are confirmed via email</li>
            <li>Payments must be made in full</li>
            <li>Prices are subject to change without notice</li>
          </ul>

          <h2 className="mt-4 mb-3">5. Shipping and Delivery</h2>
          <p>
            Delivery timelines are estimates. Risk transfers to the customer upon delivery.
          </p>

          <h2 className="mt-4 mb-3">6. No Return / No Refund Policy</h2>
          <p>
            All sales are final. No returns or refunds are provided unless explicitly agreed
            in writing.
          </p>

          <h2 className="mt-4 mb-3">7. Intellectual Property</h2>
          <p>
            All content on this website, including text, images, logos, and designs, is the
            property of Balvindra Instruments Corporation and may not be used without
            permission.
          </p>

          <h2 className="mt-4 mb-3">8. Limitation of Liability</h2>
          <p>
            We are not liable for any direct or indirect damages arising from use of the
            website or products.
          </p>

          <h2 className="mt-4 mb-3">9. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Balvindra Instruments Corporation from
            claims arising from misuse of the website.
          </p>

          <h2 className="mt-4 mb-3">10. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India. Courts in Ambala Cantt, Haryana
            shall have exclusive jurisdiction.
          </p>

          <h2 className="mt-4 mb-3">11. Contact Information</h2>
          <p>
            <strong>Balvindra Instruments Corporation</strong><br />
            Email: <a href="mailto:balco@scientificinstruments.in" className="text-decoration-none text-dark">balco@scientificinstruments.in</a><br />
            Address: 3586 Timber Market, Cross Road No. 4, Ambala Cantt, Haryana, India
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;

